export const calculateAvgValue = (amount: number, count: number): number => (count ? amount / count : 0)